import React from 'react';

const SvgIcon = ({icon: Icon, color, width, height, ...props}) => (
  <Icon fill={color} width={width} height={height} {...props} />
);

export default SvgIcon;
